"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "plesio": {
    "ecfd2c13": [{
      "hkey": "c46f1540",
      "slug": "plesio",
      "name": "Plesio",
      "primary": true,
      "skipSearch": false
    }],
    "calveseglio": [{
      "hkey": "c46f1540",
      "slug": "plesio",
      "name": "Plesio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ded24b7f": [{
      "hkey": "c46f1540",
      "slug": "plesio",
      "name": "Plesio",
      "primary": true,
      "skipSearch": false
    }],
    "ligomena": [{
      "hkey": "c46f1540",
      "slug": "plesio",
      "name": "Plesio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1ae85ecd": [{
      "hkey": "c46f1540",
      "slug": "plesio",
      "name": "Plesio",
      "primary": true,
      "skipSearch": false
    }],
    "logo": [{
      "hkey": "c46f1540",
      "slug": "plesio",
      "name": "Plesio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;